import { Component, OnInit, HostListener } from '@angular/core';
import { LocalStorageService } from 'ngx-store';
import { Router } from '@angular/router';
@Component({
  selector: 'app-left-navbar',
  templateUrl: './left-navbar.component.html',
  styleUrls: ['./left-navbar.component.scss']
})
export class LeftNavbarComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    var elmnt = document.getElementById("sideNav");
    if (elmnt.offsetWidth > 757) {
      document.getElementById("mySidenav").style.width = "250px";
      //@ts-ignore
      $("body .overlayMain").removeClass("mystyle");
    } else {
      if (document.getElementById("mySidenav").style.width == "250px") {
        //@ts-ignore
        $("body .overlayMain").addClass("mystyle");
      } else {
        //@ts-ignore
        $("body .overlayMain").removeClass("mystyle");
      }
    }
  }

  constructor(public ls: LocalStorageService,
    public router: Router) { }

  ngOnInit() {
  }
  openNav() {
    document.getElementById("mySidenav").style.width = "250px";
    //@ts-ignore
    $("body .overlayMain").addClass("mystyle");
  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    //@ts-ignore
    $("body .overlayMain").removeClass("mystyle");
  }
}
